<template lang="html">
  <div :title="ad.name">
    <a :href="ad.PathRedirectUrl" target="_blank">
      <div class="image">
        <img :src="!isLarge ? ad.PathUrl : ad.PathUrlLarge" :alt="ad.name">
      </div>
    </a>
  </div>
</template>

<script>
export default {
  props: {
    isLarge: Boolean
  },
  data() {
    return {
      ad: {}
    }
  },
  methods: {
    getAds() {
      let vm = this
      axios.get('/guidelines')
      .then(function (response) {
        vm.ad = response.data.data
      })
      .catch(function (error) {
        console.log(error)
        vm.ad = error.response.data.message
      })
    }
  },
  mounted() {
    let vm = this
    vm.getAds()
  }
}
</script>

<style lang="sass" scoped>
  img
    max-height: 310px
    object-fit: contain
</style>



// WEBPACK FOOTER //
// resources/js/components/BaseAds.vue